import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';

type Props = {
    contentMarketing: TImprovedContentMarketing;
    children: any;
    className?: string;
};
const FabricAnchorCard = ({ children, className = '' }: Props) => {
    return (
        <div
            className={
                className +
                'rounded-8 relative shadow-m overflow-hidden cursor-pointer s-bg hover:s-bg-selected w-full'
            }
        >
            {children}
        </div>
    );
};

export default FabricAnchorCard;

export const NonCardAnchorWrapper = ({ children }: Props) => {
    return (
        <div
            className={`relative w-full overflow-hidden transition-all rounded-8 hover:bg-aqua-50 hover:s-bg-selected-hover shadow-s p-8`}
        >
            {children}
        </div>
    );
};
